import React, { useState, useCallback, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Slider from "@mui/material/Slider";
import Cropper from "react-easy-crop";
import "./cropstyles.css";
import { fileToDataUrl, getCroppedImg } from "../../../hooks/useImageCrop";

const ImageCropDialog = ({ open, file, aspect = 1, onClose, onCrop }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  useEffect(() => {
    let mounted = true;
    if (file) {
      fileToDataUrl(file).then((dataUrl) => {
        if (mounted) setImageSrc(dataUrl);
      });
    }
    return () => (mounted = false);
  }, [file]);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = useCallback(async () => {
    if (!imageSrc || !croppedAreaPixels) return;
    const blob = await getCroppedImg(imageSrc, croppedAreaPixels);
    onCrop && onCrop(blob);
    onClose && onClose();
  }, [imageSrc, croppedAreaPixels, onCrop, onClose]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <div className="crop-dialog-root">
          {imageSrc ? (
            <div className="crop-container">
              <Cropper
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={aspect}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>
          ) : (
            <div>Loading image...</div>
          )}

          <div className="controls">
            <div className="zoom-slider">
              <span style={{ fontSize: 12 }}>Zoom</span>
              <Slider
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                onChange={(e, v) => setZoom(v)}
              />
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleCrop} color="primary">
          Crop & Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageCropDialog;
